<template>
  <div class="transcription-header">
    <div v-if="!editing" class="static-header button-group">
      <template v-if="isCurrentItemOwner">
        <TranscriptionCopyButton />
        <TranscriptionCorrectButton :editing="editing" @click="updateEditing(true)" />
        <TranscriptionRegenerateButton v-if="hasAiAddon" />
      </template>
      <template v-else>
        <TranscriptionCopyButton />
      </template>
    </div>
    <div v-if="editing && isCurrentItemOwner" class="correction-header">
      <h6 class="correction-header-title">Correction mode</h6>
      <div class="button-group">
        <TranscriptionCorrectionRestoreButton @click="updateEditing(false)" />
        <TranscriptionCorrectionSaveButton @update:editing="updateEditing" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUser } from '@/modules/viewer/composables/useUser';

import TranscriptionCopyButton from './button/TranscriptionCopyButton.vue';
import TranscriptionCorrectButton from './button/TranscriptionCorrectButton.vue';
import TranscriptionRegenerateButton from './button/TranscriptionRegenerateButton.vue';

import TranscriptionCorrectionRestoreButton from './button/TranscriptionCorrectionRestoreButton.vue';
import TranscriptionCorrectionSaveButton from './button/TranscriptionCorrectionSaveButton.vue';
import { useAddon } from '@/modules/viewer/composables/useAddon';

defineProps({
  editing: Boolean,
});

const { hasAiAddon } = useAddon();
const { isCurrentItemOwner } = useUser();

const emit = defineEmits(['update:editing']);
const updateEditing = (value: boolean) => emit('update:editing', value);
</script>

<style scoped>
.button-group,
.correction-header {
  @apply flex gap-2 items-center;
}
.transcription-header {
  @apply sticky top-2 z-10 mb-6;
}
.static-header {
  @apply -m-2 p-2 bg-white dark:bg-zinc-900 border-b border-slate-300 dark:border-zinc-600;
}
.correction-header {
  @apply -m-2 p-2 justify-between bg-slate-800 dark:bg-zinc-700 rounded-10;
}

.correction-header-title {
  @apply ml-2 text-sm font-bold text-white;
}
</style>
